import { type DehydratedState, dehydrate } from '@tanstack/react-query';
import type { GetServerSideProps, NextPage } from 'next';
import router from 'next/router';
import { useEffect } from 'react';
import { REDIRECT_PATH } from '@/common';
import { useUserContext } from '@/provider';
import { createTrpcHelpers } from '@/trpc/helpers';
import { getQueryClient } from '@/utils/query-client';

const Index: NextPage = () => {
  const { userInfo } = useUserContext();

  useEffect(() => {
    if (userInfo === undefined) {
      return;
    }
    router.replace(REDIRECT_PATH);
  }, [userInfo]);
  return null;
};

export default Index;

export const getServerSideProps: GetServerSideProps<{
  dehydratedState: DehydratedState;
}> = async (ctx) => {
  const queryClient = getQueryClient();
  const helpers = await createTrpcHelpers({ headers: ctx.req.headers });

  const queryIndex = ctx.resolvedUrl.indexOf('?');
  const search = queryIndex === -1 ? '' : ctx.resolvedUrl.slice(queryIndex);

  try {
    const navigation = await queryClient.fetchQuery(
      helpers.navigation.queryOptions(),
    );

    if (navigation.loginUser) {
      return {
        redirect: {
          permanent: false,
          destination: `${REDIRECT_PATH}${search}`,
        },
      };
    }
  } catch {
    // do nothing
  }

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  };
};
